import { defineComponent as _defineComponent } from 'vue';
import { faCheckSquare, faSquare, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";
import { BListGroupItem, BSpinner } from "bootstrap-vue";
export default /*#__PURE__*/ _defineComponent({
    __name: 'ConfigurationTestItem',
    props: {
        status: null
    },
    setup(__props) {
        return { __sfc: true, faCheckSquare, faSquare, faTimes, FontAwesomeIcon, BListGroupItem, BSpinner };
    }
});
